var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgChevronBold = function SvgChevronBold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7.671,
    height: 13.584,
    viewBox: "0 0 7.671 13.584"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.207 0.206)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.557,0a.908.908,0,0,0-.6.248L.277,5.7A.911.911,0,0,0,1.54,7.011L6.586,2.165l5.045,4.846A.911.911,0,0,0,12.894,5.7L7.218.249A.908.908,0,0,0,6.558,0Z",
    transform: "translate(7.264) rotate(90)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.4
  }))));
};
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI3LjY3MSIgaGVpZ2h0PSIxMy41ODQiIHZpZXdCb3g9IjAgMCA3LjY3MSAxMy41ODQiPg0KICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAuMjA3IDAuMjA2KSI+DQogICAgICAgIDxwYXRoIGQ9Ik02LjU1NywwYS45MDguOTA4LDAsMCwwLS42LjI0OEwuMjc3LDUuN0EuOTExLjkxMSwwLDAsMCwxLjU0LDcuMDExTDYuNTg2LDIuMTY1bDUuMDQ1LDQuODQ2QS45MTEuOTExLDAsMCwwLDEyLjg5NCw1LjdMNy4yMTguMjQ5QS45MDguOTA4LDAsMCwwLDYuNTU4LDBaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg3LjI2NCkgcm90YXRlKDkwKSIgZmlsbD0iY3VycmVudENvbG9yIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIwLjQiLz4NCiAgICA8L2c+DQo8L3N2Zz4NCg==";
export { SvgChevronBold as ReactComponent };